import { render, staticRenderFns } from "./AiCoachCard.vue?vue&type=template&id=8764f308"
import script from "./AiCoachCard.vue?vue&type=script&lang=js"
export * from "./AiCoachCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports